import { useState, useRef, useEffect } from 'react';
import { css, etiColors } from '@eti/styles';
import { resetButtonStyles } from '../utils/summaryStyles';
import EditSeatIcon from './SummaryEditSeatIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getButtonColor = type => {
  switch (type) {
    case 'edit':
      return etiColors.info.solid;
    case 'remove':
      return etiColors.critical.solid;
    default:
      return etiColors.info.solid;
  }
};
const buttonStyles = (type, isHighlighted) => css`
  ${resetButtonStyles}; /* stylelint-disable-next-line */
  align-items: center;
  background-color: ${isHighlighted ? getButtonColor(type) : 'transparent'};
  color: ${etiColors.white};
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 100%;
  justify-content: center;
  padding: 0.625rem 0.75rem 0.5625rem;

  @media (min-width: 48em) {
    padding: 0.875rem 0.875rem 0.9375rem;
  }

  &:focus {
    outline: 0;

    & svg {
      fill: ${!isHighlighted ? getButtonColor(type) : etiColors.white};
    }
  }

  &:hover {
    & svg {
      fill: ${!isHighlighted ? getButtonColor(type) : etiColors.white};
    }
  }
`;
const labelStyles = css`
  font-size: 0.8125rem;
  margin-right: 0.5rem;

  html[dir='rtl'] & {
    margin-left: 0.5rem;
    margin-right: auto;
  }
`;
const SummaryEditButton = _ref => {
  let {
    dataTestId,
    iconType,
    label,
    onClick
  } = _ref;
  const innerRef = useRef(null);
  const [isHighlighted, setIsHighlighted] = useState(false);
  const handleClick = () => {
    if (isHighlighted && onClick) {
      onClick();
    }
    setIsHighlighted(prevHighlighted => !prevHighlighted);
  };
  const handleClickOutside = event => {
    if (innerRef.current && !innerRef.current.contains(event.target)) {
      setIsHighlighted(false);
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  });
  return /*#__PURE__*/_jsxs("button", {
    className: buttonStyles('button', isHighlighted),
    "data-testid": dataTestId,
    onClick: handleClick,
    ref: innerRef,
    type: "button",
    children: [isHighlighted && /*#__PURE__*/_jsx("span", {
      className: labelStyles,
      children: label
    }), /*#__PURE__*/_jsx(EditSeatIcon, {
      iconType: iconType,
      isHighlighted: isHighlighted
    })]
  });
};
export default SummaryEditButton;
//# sourceMappingURL=SummaryEditSeatButton.js.map